'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _Plus = _interopRequireDefault(require('./lib/icons/Plus'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _Plus;
  exports.default = _default;
  module.exports = _default;